import { render, staticRenderFns } from "./ConversationDetails.vue?vue&type=template&id=2a3c792b&scoped=true&"
import script from "./ConversationDetails.vue?vue&type=script&lang=js&"
export * from "./ConversationDetails.vue?vue&type=script&lang=js&"
import style0 from "./ConversationDetails.vue?vue&type=style&index=0&id=2a3c792b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3c792b",
  null
  
)

export default component.exports